import Cookies from 'js-cookie';

export const ADMIN = 'admin';
export const SELLER = 'seller';
export const EMPLOYEE = 'employee';

// cb(qualified)
export function required_roles(roles, cb) {
  const usercache = Cookies.getJSON('usercache') || {
    role: ''
  };
  var has_role = false;
  if (roles.indexOf(usercache.role) > -1) {
    has_role = true;
  }
  cb(has_role);
}

export function check_roles(roles) {
    const usercache = Cookies.getJSON('usercache') || {};
    const reducer = (acc, curr) => {
        var val = false;
        if (roles.indexOf(curr) > -1) {
            val = !!usercache[curr];
        }
        return val || acc;
    };
    var has_role = Object.keys(usercache).reduce(reducer, false);
    return has_role;
}



// WEBPACK FOOTER //
// ./src/utils/roles/role_checker.js